<template>
  <div class="vx-row">
    <div class="vx-col w-full flex flex-col">
      <vs-button
        @click="$router.push({name: 'counter-create'})"
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        class="mb-4 self-end"
        size="medium"
      >Tambah Loket</vs-button>
      <vs-card>
        <div slot="header">
          <div class="vx-row m-2">
            <h3>List Loket</h3>
          </div>
        </div>
        <div class="flex flex-col">
          <vs-table :data="counter">
            <template slot="thead">
              <vs-th>No.</vs-th>
              <vs-th>Nama Loket</vs-th>
              <vs-th>Deskripsi</vs-th>
              <vs-th>Status</vs-th>
              <vs-th>Action</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
                <vs-td :data="indextr">{{ indextr }}</vs-td>
                <vs-td :data="tr.counter_name">{{ tr.counter_name }}</vs-td>
                <vs-td :data="tr.counter_description">{{ tr.counter_description }}</vs-td>
                <vs-td :data="tr.status">
                  <vs-chip v-if="tr.status == 1" color="green">Aktif</vs-chip>
                  <vs-chip v-else color="warning">Tidak Aktif</vs-chip>
                </vs-td>
                <vs-td>
                  <div class="vx-row">
                    <vs-button
                      @click="$router.push({name: 'counter-edit', params: {id: tr.id}})"
                      color="success"
                      size="small"
                      class="m-1"
                      type="border"
                      icon-pack="feather"
                      icon="icon-edit"
                    >Edit</vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      counter: []
    };
  },
  mounted() {
    this.getDataCounter();
  },
  methods: {
    getDataCounter() {
      this.$vs.loading();
      this.$http
        .get(`/app/secure/counter/getCounter`)
        .then(r => {
          this.counter = r.data.data.counter;
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    }
  }
};
</script>>
